/** @format */
import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import Card from "../../components/Card";

//image
import banner from "src/assets/images/page-img/banner.png";

// FsLightbox
import ReactFsLightbox from "fslightbox-react";
import { useNavigate } from "react-router-dom";

const FsLightbox = ReactFsLightbox.default
  ? ReactFsLightbox.default
  : ReactFsLightbox;
const EmpIndex = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/e/create-profile");
  };

  return (
    <>
      <div id="content-page" className="content-inner">
        <br></br>

        <Container>
          <Row className="gx-4">
            <Col lg={12}>
              <Card className="card-block card-stretch border border-slate-100 hover:border-slate-400 hover:bg-blue-100 transition-colors duration-200">
                <img src={banner} alt="index_banner" />

                <Card.Body>
                  <div className="d-flex flex-column align-items-center">
                    <h3 className="p-2">
                      Ready to find the perfect candidate?
                    </h3>
                    <h5 className="pb-2">
                      Start by creating your employer profile
                    </h5>
                    <Button onClick={handleClick}>
                      Create Your Employer Profile
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default EmpIndex;
